import React from "react";
import ShareItForwardSettings from "../../../components/shareItForward/ShareItForwardSettings";
import {
  getPayItForward,
  enablePayItForward,
  disablePayItForward,
  savePayItForwardRules,
} from "../../../services/medium";

/**
 * The medium's own self-service Share it Forward settings page. Thin
 * wrapper around the shared ShareItForwardSettings UI — see that component
 * for all the actual logic/markup. This file only supplies which API
 * endpoints to call (the medium's own, resolved via Auth::id() on the
 * backend) and the breadcrumb text.
 *
 * The admin-side equivalent (an admin editing a specific medium's settings)
 * is src/pages/admin/mediumShareItForward/index.js, which renders the same
 * shared component with different API functions bound to a target medium id
 * instead.
 */
export default function PayItForward() {
  return (
    <ShareItForwardSettings
      crumbLabel="Medium Dashboard"
      fetchSettingsApi={getPayItForward}
      enableApi={enablePayItForward}
      disableApi={disablePayItForward}
      saveRulesApi={savePayItForwardRules}
    />
  );
}
